import React, { useEffect, useState } from "react";
import Nav from "../Nav";
import Footer from "../Footer";
import News from "../news/News";
import { useAuthContext } from "../context/AuthContext";
import { useFavourite } from "../context/FavouriteContext";
import useHttp from "../hook/http";
import "../news/HomePage.css";
import SkeletonCard from "../SkeletonCard";

function HomePage() {
  const { currentUser } = useAuthContext();
  const { favourites } = useFavourite();
  const { data, sendRequest, isLoading } = useHttp();

  const [topNews, setTopNews] = useState([]);

  useEffect(() => {
    const url =
      "https://info-server.vercel.app/api/news/top-headlines?page=1&limit=6";

    sendRequest(url);
  }, [sendRequest]);

  useEffect(() => {
    if (data?.articles) {
      setTopNews(data.articles);
    }
  }, [data]);

  return (
    <>
      <Nav />

      <main className="home_container">

        {/* HERO SECTION */}
        <section className="hero_section">
          <h2 className="section_title">Top Headlines</h2>

          {isLoading ? (
            <div className="main_container">
              {Array.from({ length: 6 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))}
            </div>
          ) : (
            <News news={topNews} />
          )}
        </section>

        {/* USER FAVORITES */}
        {currentUser && favourites.length > 0 && (
          <section className="fav_section">
            <h2 className="section_title">Your Favorites</h2>
            <News news={favourites.slice(0, 4)} />
          </section>
        )}

        {/* LATEST NEWS */}
        <section className="latest_section">
          <h2 className="section_title">Latest News</h2>

          {isLoading ? (
            <div className="main_container">
              {Array.from({ length: 8 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))}
            </div>
          ) : (
            <News news={topNews} />
          )}
        </section>

      </main>

      <Footer />
    </>
  );
}

export default HomePage;